import CanvasDownload from '../../modules/canvasDownload';
import '~/js/modules/stickyNav';
const image = document.querySelector('.image-slideshow img');
const cdnPath = 'https://cdn.sandals.com/beaches/v12/images/media-gallery';
const imagesArray = beaches_app.page.imagesArray;
const homeURI = `/${window.location.href.split('/')[3]}/${window.location.href.split('/')[4]}/`;
const imageJSON = JSON.parse(imagesArray.substring(0, imagesArray.length - 3) + '}]');
const imageName = window.location.href.split('/')[6];
const nextLink = document.querySelector('.shadow-box.next');
const previousLink = document.querySelector('.shadow-box.previous');
const counter = document.querySelector('.image-slide-counter p');
const images = imageJSON.length;
const facebook = document.getElementById('facebook');
const pinterest = document.getElementById('pinterest');
const slideShowWrapper = document.querySelector('.slideshow-wrapper');
const header = document.querySelector('.header.js-header');
const resortMenu = document.querySelector('.top-resort-menu');
const resortName = document.getElementById('resortName').value;
let currentObject;
const pageWidth = window.innerWidth || document.body.clientWidth;
const treshold = Math.max(1, Math.floor(0.01 * (pageWidth)));
let touchstartX = 0;
let touchstartY = 0;
let touchendX = 0;
let touchendY = 0;
const limit = Math.tan(45 * 1.5 / 180 * Math.PI);
const gestureZone = document.querySelector('.image-slideshow');

const search = (nameKey, myArray) => {
  myArray.forEach((item) => {
    // console.log(item.imageName, nameKey);
    if (item.imageName === nameKey) {
      currentObject = item;
    }
  });
};

search(imageName, imageJSON);

const getContent = (url, addEntry, next) => {
  image.classList.remove('active');

  const index = imageJSON.indexOf(currentObject);
  let nextObject;
  let previousObject;

  if (index >= 0 && index < images) {
    if (next === true) {
      if (index + 1 === images - 1) {
        nextObject = imageJSON[0];
        previousObject = imageJSON[index];
        currentObject = imageJSON[index + 1];
      } else if (index + 1 === images) {
        nextObject = imageJSON[1];
        previousObject = imageJSON[images - 1];
        currentObject = imageJSON[0];
      } else {
        nextObject = imageJSON[index + 2];
        previousObject = imageJSON[index];
        currentObject = imageJSON[index + 1];
      }
    } else {
      if (index === 1) {
        previousObject = imageJSON[images - 1];
        currentObject = imageJSON[index - 1];
        nextObject = imageJSON[index];
      } else if (index === 0) {
        previousObject = imageJSON[images - 2];
        currentObject = imageJSON[images - 1];
        nextObject = imageJSON[index];
      } else {
        previousObject = imageJSON[index - 2];
        currentObject = imageJSON[index - 1];
        nextObject = imageJSON[index];
      }
    }
  }

  const loaded = () => {
    image.classList.add('active');
  };


  document.title = `Photo Gallery ‐ Image ${currentObject.order} of ${images}`;

  nextLink.querySelector('a').setAttribute('href', nextObject.uri);
  previousLink.querySelector('a').setAttribute('href', previousObject.uri);

  counter.innerHTML = `${currentObject.order}/${images}`;
  facebook.setAttribute('href', `https://www.facebook.com/sharer/sharer.php?u=https://www.beaches.com/${window.location.href.split('/')[3]}/${window.location.href.split('/')[4]}/${currentObject.imageName}/`);
  pinterest.setAttribute('href', `http://www.pinterest.com/pin/create/button/?url=https://www.beaches.com/${window.location.href.split('/')[3]}/${window.location.href.split('/')[4]}/${currentObject.imageName}/&media=${cdnPath}${url.substr(0, url.length - 1)}.jpg&description=${resortName}`);
  image.src = `${cdnPath}${url.substr(0, url.length - 1)}.jpg`;

  if (image.complete) {
    loaded();
  } else {
    image.addEventListener('load', loaded);
  }

  if (addEntry === true) {
    history.pushState(null, null, url);
  }
};

const fullScreen = () => {
  document.querySelector('body').classList.add('full-screen-img');
  slideShowWrapper.classList.add('full-screen-img');
  header.classList.add('full-screen-img');
  resortMenu.classList.add('full-screen-img');
};

const closeFullScreen = () => {
  document.querySelector('body').classList.remove('full-screen-img');
  slideShowWrapper.classList.remove('full-screen-img');
  header.classList.remove('full-screen-img');
  resortMenu.classList.remove('full-screen-img');
};

const handleGesture = () => {
  const x = touchendX - touchstartX;
  const y = touchendY - touchstartY;
  const yx = Math.abs(y / x);

  if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
    if (yx <= limit) {
      if (x < 0) {
        nextLink.click();
      } else {
        previousLink.click();
      }
    }
  }
};

gestureZone.addEventListener('touchstart', (event) => {
  touchstartX = event.changedTouches[0].screenX;
  touchstartY = event.changedTouches[0].screenY;
}, false);

gestureZone.addEventListener('touchend', (event) => {
  touchendX = event.changedTouches[0].screenX;
  touchendY = event.changedTouches[0].screenY;
  handleGesture();
}, false);

const backButton = _.debounce(() => {
  window.location.assign(homeURI);
}, 300);

window.addEventListener('popstate', backButton);

document.onkeydown = (e) => {
  const key = e || window.event;

  switch (key.which) {
    case 37:
      previousLink.click();
      break;
    case 39:
      nextLink.click();
      break;
    case 27:
      closeFullScreen();
      break;
    default:
      return;
  }
  e.preventDefault();
};

const imgObject = new CanvasDownload();

imgObject.createWaterMark();

document.onclick = (event) => {
  const target = event.target;

  if (!Element.prototype.matches) {
    if (target.webkitMatchesSelector) {
      target.matches = target.webkitMatchesSelector;
    }

    if (target.msMatchesSelector) {
      target.matches = target.msMatchesSelector;
    }

    if (target.mozMatchesSelector) {
      target.matches = target.mozMatchesSelector;
    }
  }

  if (target.matches('.shadow-box, .shadow-box *')) {
    event.preventDefault();
    let link;
    let next = false;

    if (target.classList.contains('shadow-box')) {
      link = target.querySelector('a').getAttribute('href');
      if (target.classList.contains('next')) {
        next = true;
      }
    } else if (target.tagName === 'I') {
      link = target.parentElement.getAttribute('href');
      if (target.parentElement.parentElement.classList.contains('next')) {
        next = true;
      }
    } else {
      link = target.getAttribute('href');
      if (target.parentElement.classList.contains('next')) {
        next = true;
      }
    }
    getContent(link, true, next);

    return false;
  }

  if (target.matches('.expand-image, .expand-image *')) {
    fullScreen();
  }

  if (target.matches('.close')) {
    closeFullScreen();
  }

  if (target.matches('.js-download, .js-download *')) {
    const imageObject = new CanvasDownload();

    imageObject.createCanvas();
    imageObject.convertImageToCanvas();
  }

  return true;
};
